// Number / currency formatting helpers used across both Simple and Detail pages.
// Pure functions, no engine dependencies. Safe to import from anywhere.

const DISPLAY_CURRENCY = '$';
const USD = '$';

const fmtNumber = (n, opts = {}) =>
  n.toLocaleString('en-US', { maximumFractionDigits: 0, ...opts });

export const fmtEur0 = (n) => `${DISPLAY_CURRENCY}${fmtNumber(Math.round(n))}`;
export const fmtUsd0 = (n) => `${USD}${fmtNumber(Math.round(n))}`;

export const fmtEur2 = (n) =>
  `${DISPLAY_CURRENCY}${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtCompactEur = (n) => {
  const sign = n < 0 ? '−' : '';
  const a = Math.abs(n);
  if (a >= 1e9) return `${sign}${DISPLAY_CURRENCY}${(a / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `${sign}${DISPLAY_CURRENCY}${(a / 1e6).toFixed(2)}M`;
  if (a >= 1e3) return `${sign}${DISPLAY_CURRENCY}${(a / 1e3).toFixed(1)}k`;
  return `${sign}${DISPLAY_CURRENCY}${Math.round(a)}`;
};

export const fmtCompactUsers = (n) => {
  if (n >= 1e6) return `${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1)}k`;
  return fmtNumber(Math.round(n));
};

export const fmtPct = (n, decimals = 1) => `${(n * 100).toFixed(decimals)}%`;

export const fmtPct0 = (n) => fmtPct(n, 0);

// "+$1,234" / "-$1,234" — for delta cards
export const fmtSignedEur = (n) => {
  if (n > 0) return `+${fmtCompactEur(n)}`;
  if (n < 0) return fmtCompactEur(n); // already has minus
  return fmtCompactEur(0);
};

export const fmtMonths = (n) => {
  if (n == null || !Number.isFinite(n)) return '—';
  if (n < 1) return '<1 mo';
  if (n < 12) return `${Math.round(n)} mo`;
  const years = n / 12;
  return `${years.toFixed(1)} yr`;
};
